import { Reducer, Dispatch } from "redux";
import { SET_EXAMINATION_ORGANIZATIONS } from "../actions/examinationOrganizationsActions";
import { getExaminationOrganizations } from "../api/examinationOrganizations";
import { IExaminationOrganization } from "../models/examinationOrganization";

const initialState: IExaminationOrganization[] = [];

export const examinationOrganizationsReducer: Reducer<IExaminationOrganization[]> = (
    state = initialState,
    action: any
): IExaminationOrganization[] => {
    switch (action.type) {
        case SET_EXAMINATION_ORGANIZATIONS:
            return action.payload;
        default:
            return state;
    }
};

export async function fetchExaminationOrganizations(dispatch: Dispatch) {
    const res = await getExaminationOrganizations();
    dispatch({ type: SET_EXAMINATION_ORGANIZATIONS, payload: res });
}
